import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { ChatTelegram } from "../../types/chat-telegram.types";
import { TelegramBloggersService } from "../../services/telegram-bloggers.service";
import { TelegramAccountsService } from "../../services/telegram-accounts.service";
import { TelegramPageService } from "../../services/telegram-page.service";
import { TelegramPollingService } from "../../services/telegram-polling.service";
import { ChatsPollingService } from "../../services/chats-polling.service";
import { telegramPagePollingInterval } from "../../../../../core/models/polling-config";
import { MatMiniFabButton } from "@angular/material/button";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-telegram-bloggers',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule
  ],
  templateUrl: './telegram-bloggers.component.html',
  styleUrls: [
    './telegram-bloggers.component.scss',
    '../telegram-components-styles.scss'
  ]
})
export class TelegramBloggersComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) chats: Array<ChatTelegram> = [];
  @Input({ required: true }) selectedChat?: ChatTelegram | null;
  @Input({ required: true }) isVisibleBloggers: boolean = false;
  @Output() handleSelectChat: EventEmitter<ChatTelegram> = new EventEmitter<ChatTelegram>();
  @Output() toggleBlogger: EventEmitter<void> = new EventEmitter<void>();

  private telegramBloggersService: TelegramBloggersService = inject(TelegramBloggersService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private telegramPageService: TelegramPageService = inject(TelegramPageService);
  private telegramPollingService: TelegramPollingService = inject(TelegramPollingService);
  private chatsPollingService: ChatsPollingService = inject(ChatsPollingService);

  public searchBlogger: string = '';
  public searchChats: Array<ChatTelegram> = [];

  public ngOnChanges(changes:SimpleChanges): void {
    if (changes['chats']) {
      this.loadProfilePhotos();
      this.startChatsPolling();
    }

    this.handleSearchChats();
  }

  public ngOnDestroy(): void {
    this.chatsPollingService.stopPolling();
  }

  public handleSearchChats(): void {
    const searchTerm = this.searchBlogger?.toLowerCase().trim() || '';
    this.searchChats = searchTerm
      ? this.chats?.filter(chat => chat.title.toLowerCase().includes(searchTerm)) ?? []
      : this.chats ?? [];
  }

  public handelToggleBlogger() {
    this.toggleBlogger.emit();
  }

  public handleSelectChatClick(chat: ChatTelegram): void {
    if (chat.id === this.selectedChat?.id) { return; }

    this.handleSelectChat.emit(chat);
    this.selectedChat = chat;
  }

  public isChatActive(chat: ChatTelegram): boolean {
    return this.selectedChat?.id === chat.id;
  }

  public getImage(id: number): string {
    return this.telegramBloggersService.getBloggerImage(id);
  }

  private startChatsPolling(): void {
    const chatsQueryParams = this.telegramPageService.setChatsQueryParams();

    this.telegramPollingService.getChatsWithPolling({
      params: chatsQueryParams,
      intervalMs: telegramPagePollingInterval,
      callback: (chats) => {
        if (this.telegramPageService.hasChatsChanged(chats, this.chats)) {
          this.chats = chats;
          this.searchChats = chats;
        }
      }
    });
  }

  private loadProfilePhotos(): void {
    if (this.chats?.length) {
      this.chats?.forEach(async (chat) => {
        if (chat.profilePhotoUrl) {
          await this.telegramBloggersService.setBloggersImage({
            chat: chat,
            accountId: this.telegramAccountsService.selectedAccount().accountId
          });
        }
      });
    }
  }
}
